import ChatDetailInfoLeave from '@/screens/ChatDetailInfoLeave';

export default function PrivateChatChatIdInfoLeaveRoute() {
  return <ChatDetailInfoLeave />;
}
